var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E5F2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5359 22.4913L22.0746 27.03L32.5241 16.5805C32.9111 16.1935 33.4037 16 34.0018 16C34.5999 16 35.0925 16.1935 35.4795 16.5805C35.8665 16.9675 36.06 17.4601 36.06 18.0582C36.06 18.6563 35.8665 19.1489 35.4795 19.5359L23.5523 31.4631C23.1301 31.8853 22.6375 32.0964 22.0746 32.0964C21.5117 32.0964 21.0191 31.8853 20.5969 31.4631L14.5805 25.4467C14.1935 25.0597 14 24.5672 14 23.969C14 23.3709 14.1935 22.8784 14.5805 22.4913C14.9675 22.1043 15.4601 21.9108 16.0582 21.9108C16.6563 21.9108 17.1489 22.1043 17.5359 22.4913Z",
    fill: "#7EBE39"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWon);
export default __webpack_public_path__ + "static/media/Won.c850ec0a41eb1b615e601fa8b0ba6611.svg";
export { ForwardRef as ReactComponent };